import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"line-height":"1"} }
const _hoisted_4 = { class: "text-weight-bolder" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-weight-bolder" }
const _hoisted_8 = { class: "reward_amount" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "col-12 q-py-lg q-px-md",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-6 flex items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Geo:", -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = { style: {"line-height":"1"} }
const _hoisted_16 = { class: "col-6 flex items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Payout:", -1)
const _hoisted_18 = { class: "reward_amount" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-6 flex items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Source:", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "col-6 flex items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Condition:", -1)
const _hoisted_28 = { class: "text-weight-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    id: "rates-table",
    "row-key": "id",
    columns: _ctx.columns,
    rows: _ctx.rows,
    pagination: _ctx.initialPagination,
    "hide-bottom": "",
    flat: "",
    grid: _ctx.$q.screen.width <= 1023
  }, _createSlots({
    body: _withCtx((props) => [
      _createVNode(_component_q_tr, {
        style: _normalizeStyle(
          props.row.borderColor && props.row.borderLabel
            ? `border: 2px solid ${props.row.borderColor} !important;`
            : ''
        )
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_td, {
            props: props,
            key: "geo"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  style: {"user-select":"none","display":"initial"},
                  class: "q-mr-xs",
                  height: "10",
                  width: "15",
                  src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geo}.svg`
              
                }, null, 8, _hoisted_2),
                _createElementVNode("span", _hoisted_3, _toDisplayString(props.row.geoName), 1)
              ])
            ]),
            _: 2
          }, 1032, ["props"]),
          _createVNode(_component_q_td, {
            props: props,
            key: "source"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, [
                (props.row.reward.trafficSource)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.row.reward.trafficSource.name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('all')), 1))
              ])
            ]),
            _: 2
          }, 1032, ["props"]),
          _createVNode(_component_q_td, {
            props: props,
            key: "condition"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.rewardTypes[props.row.reward.type]), 1),
              _createVNode(_component_q_tooltip, {
                anchor: "top left",
                self: "top left",
                class: "q-tooltip custom-tooltip"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.rewardTypes[props.row.reward.type]) + " " + _toDisplayString(props.row.reward.trafficSource
                ? ` - ${props.row.reward.trafficSource.name}`
                : ''), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["props"]),
          _createVNode(_component_q_td, {
            props: props,
            key: "payout"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(props.row.reward.type !== _ctx.rewardTypes.RevShare
                ? props.row.reward.value.amount +
                  ' ' +
                  _ctx.currencies[props.row.reward.value.currency]
                : props.row.reward.percent + '%'), 1),
              (props.row.reward.upsaleNumber)
                ? (_openBlock(), _createElementBlock("sup", _hoisted_9, "?"))
                : _createCommentVNode("", true),
              (props.row.reward.upsaleNumber)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 1,
                    anchor: "top left",
                    self: "top left",
                    class: "q-tooltip custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Payout for " + _toDisplayString(props.row.reward.upsaleNumber) + " deposit ", 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        _: 2
      }, 1032, ["style"])
    ]),
    _: 2
  }, [
    (_ctx.$q.screen.width <= 1024)
      ? {
          name: "item",
          fn: _withCtx((props) => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("img", {
                    style: {"user-select":"none","display":"initial"},
                    class: "q-mr-xs",
                    height: "10",
                    width: "15",
                    src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geo}.svg`
              
                  }, null, 8, _hoisted_14),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(props.row.geoName), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(props.row.reward.type !== _ctx.rewardTypes.RevShare
                  ? props.row.reward.value.amount +
                    ' ' +
                    _ctx.currencies[props.row.reward.value.currency]
                  : props.row.reward.percent + '%'), 1),
                  (props.row.reward.upsaleNumber)
                    ? (_openBlock(), _createElementBlock("sup", _hoisted_19, "?"))
                    : _createCommentVNode("", true),
                  (props.row.reward.upsaleNumber)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 1,
                        anchor: "top left",
                        self: "top left",
                        class: "q-tooltip custom-tooltip"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Выплата за " + _toDisplayString(props.row.reward.upsaleNumber) + " депозит ", 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  (props.row.reward.trafficSource)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(props.row.reward.trafficSource.name), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('all')), 1))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.rewardTypes[props.row.reward.type]), 1),
                  _createVNode(_component_q_tooltip, {
                    anchor: "top left",
                    self: "top left",
                    class: "q-tooltip custom-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rewardTypes[props.row.reward.type]) + " " + _toDisplayString(props.row.reward.trafficSource
                  ? ` - ${props.row.reward.trafficSource.name}`
                  : ''), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["columns", "rows", "pagination", "grid"]))
}